import React, { useState } from 'react';
import { navigate } from 'gatsby';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Tabs } from '../../../../components/Tabs';
import { Tab } from '../../../../components/Tab';
import { TicketSeasons } from '../ticket-seasons';
import { TicketCard, TicketCardProps } from './ticket-card';

interface Props {
  items: TicketCardProps[];
}

export const TicketCards = ({ items }: Props) => {
  const { t } = useTranslation();

  const [ticketTypeTab, setTicketTypeTab] = useState(0);

  const handleTicketTypeTabChange = (_, tab: number) => {
    setTicketTypeTab(tab);

    if (!window?.document) return;
    window.document.getElementById(items[tab].title)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  if (!items.length) return null;

  return (
    <Stack width="100%" mb={10} mt="4em">
      <Stack flexDirection="row" justifyContent="center" width="100%" mb={4} px={2}>
        <Box className="container">
          <TicketSeasons />

          <Stack spacing={3} mb={4} mt={10}>
            <Typography variant="h2" color="primary.main" fontFamily="Gotham-Medium" fontSize={32} fontWeight={500}>
              {t('tickets_service.tickets_cards.title')}
            </Typography>
            <Typography color="#302F2F" mt={2.5}>
              {t('tickets_service.tickets_cards.description')}
            </Typography>

            <Button
              variant="contained"
              color="primary"
              size="large"
              sx={{ maxWidth: 200 }}
              onClick={() => navigate('/')}
            >
              {t('tickets_service.tickets_cards.button')}
            </Button>
          </Stack>

          <Tabs
            value={ticketTypeTab}
            onChange={handleTicketTypeTabChange}
            aria-label="ticket-types-tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {items.map((item) => (
              <Tab key={item.title} label={item.title} />
            ))}
          </Tabs>
        </Box>
      </Stack>

      {items.map((item, index) => (
        <Stack
          key={item.title}
          id={item.title}
          flexDirection="row"
          justifyContent="center"
          width="100%"
          bgcolor={index % 2 === 0 ? '#FFFFFF' : '#F3F2F5'}
        >
          <TicketCard {...item} />
        </Stack>
      ))}
    </Stack>
  );
};
